import DeviceDetector from "device-detector-js";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Store } from "../interfaces/IStore";
import { AppContext, AppContextProvider } from "./AppContext";
// Importing the actual google map
import { MapComponent } from "./MapComponent";
import { MapContext, MapProvider } from "./MapContext";
import { Overlay_Desktop } from "./Overlay_Desktop";
import { Overlay_Mobile } from "./Overlay_Mobile";
import SingleStoreCard from "./SingleStoreCard";

declare global {
  interface Window {
    singleStore?: boolean;
    targetStore?: string;
    competitor?: {
      locationName?: string;
      coords?: {
        lat?: number | string;
        lng: number | string;
      };
      avgRatings: number;
      placeId: string | number;
      business_type: string;
    }[];
    data?: {
      [key: string]: any;
    };
  }
}

const deviceDetector = new DeviceDetector();
const device = deviceDetector.parse(navigator.userAgent);
const isMSafari14 = device.client?.name === "Mobile Safari" && Number(device.client?.version) >= 14;
// Styled Components
const MapContainerDiv = styled.div`
  height: calc((100vh - 135px) * 5 / 5);
  position: relative;
  overflow: hidden;

  @media screen and (max-width: 770px) {
     {
      height: calc(100vh - 120px - 40px ${isMSafari14 ? " - 80px" : ""});
    }
  }
`;

export const MapContainer = () => {
  /*useEffect(() => {
    console.log(JSON.stringify(device.client));
  }, []);*/
  // This is for the coords returned from the user's seearch input (**GOING TO BE PASSED TO THE CHILD MAP ELEMENT**)
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 770);
  const [showStore, setShowStore] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  useEffect(() => {
    const windowListener = () => {
      setIsMobile(window.innerWidth <= 770);
      console.log(window.innerWidth);
    };
    window.addEventListener("resize", windowListener);
    return () => {
      window.removeEventListener("resize", windowListener);
    };
  }, []);
  return (
    <MapContainerDiv>
      <MapProvider>
        <MapContext.Consumer>
          {(context: {
            allStores: Store[];
            stores: Store[];
            sortCoords: { lat: number; lng: number };
            setStores: (stores: Store[]) => void;
          }) => (
            <AppContextProvider
              allStores={context.allStores}
              stores={context.stores}
              coords={context.sortCoords}
              setStores={context.setStores}>
              {!window.singleStore ? (
                <>
                  {isMobile ? (<>
                    <Overlay_Mobile
                      showStore={showStore}
                      setShowStore={setShowStore}
                      showFilter={showFilter}
                      setShowFilter={setShowFilter}
                    /></>
                  ) : (
                    <Overlay_Desktop
                      showStore={showStore}
                      setShowStore={setShowStore}
                      showFilter={showFilter}
                      setShowFilter={setShowFilter}
                    />
                  )}
                </>
              ) : window.singleStore && window.targetStore ? (
                <>
                  <AppContext.Consumer>
                    {(context) => {
                      context.setSelectedStore(window.targetStore);
                      return (
                        <SingleStoreCard
                          currentStore={context.stores.find((store) => store.id === context.selectedStore)}
                          showStore={isMobile ? showStore : true}
                          closeStore={() => {
                            setShowStore((showStore) => !showStore);
                          }}
                        />
                      );
                    }}
                  </AppContext.Consumer>
                </>
              ) : null}
            </AppContextProvider>
          )}
        </MapContext.Consumer>
        <MapComponent
          openStore={() => {
            setShowStore(true);
            setShowFilter(false);
          }}
        />
      </MapProvider>
    </MapContainerDiv>
  );
};
